var app = angular.module('leonardo');

var TemplateTypeFilter = function (TemplateService, AuthDataService) {
  return function (template) {
    if (template.root_group) {
      return 'G';
    }
    if (template && (template.type !== null) && (template.type !== undefined) && (template.type !== ''))
      switch (template.type.toString()) {
        case TemplateService.TYPE_SYSTEM:
          if (AuthDataService.isAdmin() && template.client_instance){
            return 'CI';
          }
          else {
            return 'S';
          }
        case TemplateService.TYPE_ACCOUNT:
          return template.parent ? 'S' : 'A';
        case TemplateService.TYPE_PORTFOLIO:
          return 'PO';
        case TemplateService.TYPE_PROPERTY:
          return 'PR';
        case TemplateService.TYPE_ACCOUNT_USER:
          return 'U';
        case TemplateService.TYPE_TRIGGER:
          return 'T';
      }
    return 'Invalid type';
  };
};

var TemplateTypeDescriptionFilter = function (TemplateService, $filter, AuthDataService) {
  return function (template) {
    if (template && (template.type !== null) && (template.type !== undefined) && (template.type !== ''))
      switch (template.type.toString()) {
        case TemplateService.TYPE_SYSTEM:
          if (AuthDataService.isAdmin() && template.client_instance){
            return 'Client Instance';
          }
          else {
            return 'System';
          }
        case TemplateService.TYPE_ACCOUNT:
          var result = template.parent ? 'System' : 'Account';
          var accountName = $filter('accountName')(template.account);
          if (accountName ) {
            result += ' - ' + accountName;
          }
          return result;
        case TemplateService.TYPE_PORTFOLIO:
          return 'Portfolio';
        case TemplateService.TYPE_PROPERTY:
          return 'Property';
        case TemplateService.TYPE_ACCOUNT_USER:
          return 'User';
        case TemplateService.TYPE_TRIGGER:
          return 'Trigger';
      }
    return 'Invalid type';
  };
};

app.filter('templateType', ['TemplateService', 'AuthDataService', TemplateTypeFilter]);
app.filter('templateTypeDescription', ['TemplateService', '$filter', 'AuthDataService', TemplateTypeDescriptionFilter]);
